module.exports = __webpack_public_path__ + "static/media/Christie_Maly.25135510.png";